import {  AuthenticationMethodEnums } from "src/app/enums/enums";

export interface LoginCustomisation {
  organisationFeatureId: string;
  logoPath: string;
  backImagePath: string;
  backColor1: string;
  backColor2: string;
  gradientDirection: string;
  textBtnColor: string;
  btnColor: string;
  footerTextId: string;
  footerColor: string;
}

export interface IOrganisation {
  organisationId: string;
  versionId: number;
  organisationName: string;
  placeName: string;
  uniqueURL: string;
  urlType: number;
  contactName: string;
  phoneNumber: string;
  address: string;
  email: string;
  placeReference: string;
  levelTypeId: number;
  communityTemplateId: string;
  childOrganisations: any;
  organisationFeature: OrganisationFeature;
  sms2FAEnable?: boolean;
}

interface OrganisationFeature {
  organisationFeatureId: string;
  organisationId: string;
  versionId: number;
  featureId: number;
  isEnabled: boolean;
  loginCustomisation: LoginCustomisation;
}
export interface ISimpleOrganisation {
  id: string;
  organisationName: string
  parentName: string
}

export interface IOrganisationInfo {
  authenticationMethod: AuthenticationMethodEnums;
  id:string;
  name: string;
  placeName: string;
}

export interface ISamlConfigurationSimpleDto{
  id: string,
  organisationId: string
  name?: string
}
export interface IOAuth2ConfigurationSimpleDto{
  registrationId: string,
  organisationId: string
  name?: string,
  enabled?: boolean
}
export interface ISearchRequest{
  searchString: string
  pageSize?: number
  organisationIds?: string[]
}
export interface IGenaralPagination<T = any>{
  data: T[],
  currentPage:  number
  currentPageSize: number
  totalPages: number
  totalElements: number,
  pageSize: number
}
